import Vue from 'vue'
import Router from 'vue-router'
import utils from '@/common/util/utils'
import { get } from 'lodash'
import { getStorage, isSupperSessionStorage, isSupportLocalStorage } from '@/common/util/storage.util'

Vue.use(Router)

const credentialCheck = (to, from, next) => {
  const cs = JSON.parse(utils.cookies.getItem('cs'))
  const credential = get(cs, 'credential', 'none')
  if (credential === 'none') {
    alert('로그인 후 이용 하세요.')
    next({ name: 'main', query: {} })
  } else {
    next()
  }
}
// cookie

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      components: {
        partners: () => import('@/views/partners/PartnersLayout')
      },
      children: [
        {
          path: '',
          name: 'main',
          alias: 'index.html',
          props: true,
          components: {
            home: () => import('@/views/partners/Login')
          },
          beforeEnter: (to, from, next) => {
            utils.login.logoutProc().then(() => {
              next()
            })
          }
        },
        {
          path: `${Math.random().toString(36).substr(2, 10)}`,
          // path: `init`,
          name: 'initEmail',
          props: true,
          components: {
            home: () => import('@/views/partners/InitEmail')
          },
          beforeEnter: credentialCheck
        },
        {
          // path: `voucher`,
          path: `${Math.random().toString(36).substr(2, 10)}`,
          name: 'voucher',
          props: true,
          components: {
            home: () => import('@/components/lnb/voucher/voucher_promotion')
          },
          beforeEnter: credentialCheck
        },
        {
          path: 'thanks',
          name: 'complete',
          props: true,
          components: {
            home: () => import('@/views/partners/Complete')
          }
        },
        {
          path: '*',
          redirect: to => { return { name: 'main', query: {} } }
        }
      ]
    }
  ]
})

export default router
